/** Pure number/text formatting for tooltips (WoW-style: "4,612", "2 sec", "1.5 min", "40%"). */

/** Trim a number to at most `digits` decimals without trailing zeros: 1.50 -> "1.5", 2.00 -> "2". */
export function trimNum(n: number, digits = 2): string {
  if (!Number.isFinite(n)) return '0';
  const s = n.toFixed(digits);
  return s.includes('.') ? s.replace(/\.?0+$/, '') : s;
}

/** Integer with thousands separators: 4612.4 -> "4,612". */
export function fmtInt(n: number): string {
  if (!Number.isFinite(n)) return '0';
  const r = Math.round(n);
  const s = String(Math.abs(r)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return r < 0 ? `-${s}` : s;
}

/** Seconds from ms, no unit: 2000 -> "2", 1667 -> "1.67", 18000 -> "18". */
export function fmtSec(ms: number): string {
  const s = ms / 1000;
  return trimNum(s, s < 10 ? 2 : 1);
}

/** Duration with unit: 8000 -> "8 sec", 90000 -> "1.5 min", 300000 -> "5 min". */
export function fmtDuration(ms: number): string {
  if (ms >= 60_000) return `${trimNum(ms / 60_000, 1)} min`;
  return `${fmtSec(ms)} sec`;
}

/** Fraction to percent: 0.4 -> "40%", 0.125 -> "12.5%". */
export function fmtPct(f: number): string {
  return `${trimNum(f * 100, 1)}%`;
}

export function capitalize(s: string): string {
  return s ? s[0]!.toUpperCase() + s.slice(1) : s;
}

/** "holy_power" -> "Holy Power", "maelstrom" -> "Maelstrom". */
export function prettyId(id: string): string {
  return id
    .replace(/^[a-z]+\./, '')
    .split(/[_\-.\s]+/)
    .filter(Boolean)
    .map(capitalize)
    .join(' ');
}

/** "a, b and c". */
export function joinAnd(parts: readonly string[], word = 'and'): string {
  if (parts.length <= 1) return parts[0] ?? '';
  return `${parts.slice(0, -1).join(', ')} ${word} ${parts[parts.length - 1]}`;
}

/** Turn clauses into sentences: capitalize, end with a period. */
export function sentence(s: string): string {
  const t = s.trim();
  if (!t) return '';
  return capitalize(/[.!?]$/.test(t) ? t : `${t}.`);
}
